module.exports = __webpack_public_path__ + "static/media/Parkland_A_HC.8add94a7.png";